<lib-version-checker [environment]="_environment"></lib-version-checker>
<ui-notifications></ui-notifications>
<ui-errors (close)="close($event)"></ui-errors>
<router-outlet></router-outlet>
<ui-toast></ui-toast>
<e11-side-over (sideOverClosed)="sideOverClose()"></e11-side-over>
<e11-notifications></e11-notifications>
<e11-modal-global></e11-modal-global>
<sdk-conversation-side-over></sdk-conversation-side-over>
